var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92332 15.1761L10.7816 13.1126C11.2136 12.0739 12.1904 11.3642 13.3118 11.2743L15.5396 11.0957C16.4262 11.0246 16.7857 9.91808 16.1102 9.33941L14.4129 7.88548C13.5585 7.15362 13.1854 6.00529 13.4464 4.91103L13.965 2.73712C14.1714 1.87189 13.2301 1.18803 12.471 1.65169L10.5638 2.81664C9.60371 3.40304 8.39629 3.40304 7.43624 2.81664L5.52897 1.65169C4.76987 1.18803 3.82862 1.87189 4.03501 2.73712L4.55356 4.91103C4.81459 6.00529 4.44147 7.15363 3.5871 7.88548L1.88979 9.33941C1.21425 9.91808 1.57378 11.0246 2.46043 11.0957L4.68819 11.2743C5.80956 11.3642 6.78639 12.0739 7.21841 13.1126L8.07668 15.1761C8.41827 15.9974 9.58172 15.9974 9.92332 15.1761Z",
    stroke: "#DFE2E6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarUnfilled);
export default __webpack_public_path__ + "static/media/star_unfilled.2f8ba9710d14af3316d7736167a3b4ba.svg";
export { ForwardRef as ReactComponent };